import { useEffect, useRef } from 'react';
import { Layout, Grid } from 'antd';
import './styles.css';
import { useLocation } from 'react-router-dom';
import { SideMenu, BupFooter, HeaderProfile } from '@BUP/components';

const { Header, Sider, Footer, Content } = Layout;
const { useBreakpoint } = Grid;

const MainLayout = ({ children }) => {
  const contentRef = useRef(null);
  const location = useLocation();
  const screens = useBreakpoint();
  const isSmall = screens.xs || (screens.sm && !screens.lg) ? true : false;

  useEffect(() => {
    if (contentRef && contentRef.current.scrollTop > 0) {
      contentRef.current.scrollTop = 0
    }
  }, [location.pathname]);

  return (
    <div className="main_layout__container">
      <Layout className="site-layout">
        <Sider
          className="site-layout-side "
          width={260}
          collapsed={isSmall}
          collapsedWidth={210}
        >
          <SideMenu />
        </Sider>
        <div
          ref={contentRef}
          className="site-content-container"
        >
          <Layout className="site-content-wrapper">
            <Header className="site-layout-header site-layout-background">
              <HeaderProfile />
            </Header>
            <Content className="site-layout-content">
              {children}
            </Content>
            <Footer className="site-layout-footer">
              <BupFooter />
            </Footer>
          </Layout>
        </div>
      </Layout>
    </div>
  )
}

export default MainLayout;